import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const Machine = () => {
  const [modal_list, setmodal_list] = useState(false);
  const [editedMachine, setEditedMachine] = useState(null);
  const [responseMessage, setResponseMessage] = useState("");
  const [companyData, setCompanyData] = useState([]);
  const [machineData, setMachineData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
 const [isLoading, setIsLoading] = useState(false);

  //const authToken = JSON.parse(localStorage.getItem("authUser")).token;
    const authToken =localStorage.getItem("access");
  function tog_list() {
    setmodal_list(!modal_list);
    setEditedMachine(null);
  }

    useEffect(() => {
    fetchCompany();
  }, []);
  const fetchCompany = async () => {
    try {
      
      const response = await fetch("https://api.hanoch.in/api/company", {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, 
        // },
      });

      if (response.ok) {
        const data = await response.json();
        setCompanyData(data);
      } else if (response.status === 401) {
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const [formData, setFormData] = useState({
    company: "",
    ideal_cycle_time: "",
    design_capacity: "",
    topic: "",
    name: "",
    description:"",
     image: null,
    id:"",
      machine_type: "", 
       manual: false,
  });

  useEffect(() => {
    if (editedMachine) {
     
      setFormData({
        company: editedMachine.company,
        ideal_cycle_time: editedMachine.ideal_cycle_time,
        design_capacity: editedMachine.design_capacity,
        topic: editedMachine.topic,
        name: editedMachine.name,
        image: editedMachine.image || null,
        description:editedMachine.description,
        id:editedMachine.id,
          machine_type: editedMachine?.manual,
           manual: false, 
      });
    } else {
      setFormData({
        company: "",
        ideal_cycle_time: "",
        design_capacity: "",
        topic: "",
        name: "",
       image: "",
        description:"",
        id:"",
          machine_type: "", 
           manual: false,
      });
    }
  }, [editedMachine]);

 
  const handleInputChange = (e) => {
    if (e.target.type === "file") {
      setFormData({ ...formData, image: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.id]: e.target.value });
    }
  };

 
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const apiUrl = editedMachine
        ? `https://api.hanoch.in/api/machines/${editedMachine.id}/`
        : "https://api.hanoch.in/api/machines/";
  
      const formDataObject = new FormData();
  
      formDataObject.append("company", formData.company);
      formDataObject.append("ideal_cycle_time", formData.ideal_cycle_time);
      formDataObject.append("design_capacity", formData.design_capacity);
      formDataObject.append("topic", formData.topic);
      formDataObject.append("name", formData.name);
      formDataObject.append("description", formData.description);
  formDataObject.append("manual", formData.manual);
      if (formData.image) {
        formDataObject.append("image", formData.image);
      }
  
      const response = await fetch(apiUrl, {
        method: editedMachine ? "PATCH" : "POST",
        // headers: {
        //   Authorization: `Bearer ${authToken}`,
        // },
        body: formDataObject,
      });
  
      const responseData = await response.json();
  
      if (response.ok) {
        console.log(response)
        toast.success(responseData.message || "Machine saved successfully");
        setmodal_list(false);
        setEditedMachine(null); 
        setFormData({
          company: "",
          ideal_cycle_time: "",
          design_capacity: "",
          topic: "",
          name: "",
          description: "",
          image: null,
          id: "",
            machine_type:"", 
             manual: false,
        });
        fetchMachine();
      } else {
        toast.error(`Error: ${JSON.stringify(responseData)}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Unexpected error occurred");
    }
  };



  const fetchMachine = async () => {
    try {
       setIsLoading(true);
      const response = await fetch("https://api.hanoch.in/api/machines", {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, 
        // },
      });

      if (response.ok) {
        const data = await response.json();
        
        setMachineData(data?.data);
      } else if (response.status === 401) {
      
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
     } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMachine();
  }, []);
  
 
  const handleDeleteMachine = async (id) => {
    try {
      // Make API request to delete the user
      const response = await fetch(
        `https://api.hanoch.in/api/machines/${id}/`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${authToken}`, 
          },
        }
      );

      if (response.ok) {
       console.log(response)
        toast.success("Machine Deleted Successfully");
        fetchMachine();
      } else if (response.status === 401) {
        
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };
const handleSetDefaultMachine = async (machineId) => {
  try {
    const response = await fetch("https://api.hanoch.in/api/machines/", {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${authToken}`, // Uncomment if needed
      },
      body: JSON.stringify({ is_default: true ,id:machineId}), // adjust payload as needed
    });

    if (response.ok) {
      toast.success("Machine set as default successfully.");
      fetchMachine();
      // Optionally refresh machine list
    } else {
      toast.error("Failed to set default machine.");
    }
  } catch (error) {
    console.error(error);
    toast.error("An error occurred while setting the default machine.");
  }
};


  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

   const filteredMachine = machineData.filter((machine) =>
  
     machine.name.toLowerCase().includes(searchTerm.toLowerCase())
   );

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredMachine.length / itemsPerPage);

  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get the items for the current page
  const currentItems = filteredMachine.slice(indexOfFirstItem, indexOfLastItem);

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Machine" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">
                    Add, Edit & Remove Machine
                  </h4>
                </CardHeader>

                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div className="d-flex gap-1">
                          <Button
                            color="success"
                            className="add-btn"
                            onClick={() => tog_list()}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add New Machine
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light">
                          <tr>
                            <th>Logo</th>
                            <th className="sort" data-sort="customer_name">
                              Company Name
                            </th>
                            <th className="sort" data-sort="email">
                              Machine Name
                            </th>
                            <th className="sort" data-sort="email">
                              Machine Type
                            </th>
                            <th className="sort" data-sort="email">
                              Topic
                            </th>
                            <th className="sort" data-sort="phone">
                             Description
                            </th>
                            <th className="sort" data-sort="phone">
                              Ideal Cycle Time
                            </th>
                            <th className="sort" data-sort="date">
                              Design Capacity
                            </th>
                            <th className="sort" data-sort="action">
                              Action
                            </th>
                          </tr>
                        </thead>
                         {isLoading ? (
            <div className="text-center justify-content-center align-items-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
                        <tbody className="list form-check-all">
                          {currentItems === undefined ? (
                            <tr>
                              <td colSpan="9" className="text-center">
                                Loading...
                              </td>
                            </tr>
                          ) : currentItems.length === 0 ? (
                            <tr>
                              <td colSpan="9" className="text-center">
                                No content found
                              </td>
                            </tr>
                          ) : (
                            currentItems.map((machine, index) => (
                              <tr key={index}>
                                <td>
                                  {machine.image && (
                                    <div className="logo">
                                       <img src={`https://api.hanoch.in/media/${machine.image}`}  alt="machine"
                                        height="48"
                                    
                                      />
                                    </div>
                                  )}
                                </td>
                                <td className="customer_name">
                                  {machine.company}
                                </td>
                                  <td className="email">
                                  {machine.name}
                                </td>
                                 <td>
  {machine.manual ? "Manual" : "Automatic"}
</td>
                                <td className="email">{machine.topic}</td>
                                <td className="phone">
                                  {machine.description}
                                </td>
                                <td>{machine.ideal_cycle_time}</td>
                               
                                <td className="date">
                                  {machine.design_capacity}
                                </td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <div className="edit">
                                      <button
                                        className="btn btn-warning"
                                        onClick={() => {
                                          setmodal_list(true);
                                          setEditedMachine(machine);
                                        }}
                                      >
                                        Edit
                                      </button>
                                    </div>
                                    <div className="remove">
                                      <button
                                        className="btn btn-danger remove-item-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target="#deleteRecordModal"
                                        onClick={() =>
                                          handleDeleteMachine(machine.id)
                                        }
                                      >
                                        Remove
                                      </button>
                                    </div>
                                      <div className="set-default">
                                        {machine.is_default === true ? (
        <span className=" text-center align-self-center">Default</span>
      ) : (
      <button
        className="btn btn-primary"
        onClick={() => handleSetDefaultMachine(machine.id)}
      >
        Set Default
      </button>
      )}
    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
          )}
                      </table>
                      <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#121331,secondary:#08a88a"
                            style={{ width: "75px", height: "75px" }}
                          ></lord-icon>
                          <h5 className="mt-2">Sorry! No Result Found</h5>
                          <p className="text-muted mb-0">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add Modal */}
      {/* Edit Machine and Add Machine */}
      <Modal
        isOpen={modal_list}
        toggle={() => {
          setmodal_list(false);
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel"
          toggle={() => {
            tog_list();
          }}
        >
          {editedMachine ? "Edit Machine" : "Add Machine"}
        </ModalHeader>
        {responseMessage && (
          <div
            className={`alert ${
              responseMessage.includes("Error")
                ? "alert-danger"
                : "alert-success"
            } `}
          >
            {responseMessage}
          </div>
        )}
        <form className="tablelist-form">
          <ModalBody>
            <div className="mb-3" id="modal-id" style={{ display: "none" }}>
              <label htmlFor="id-field" className="form-label">
                ID
              </label>
              <input
                type="text"
                id="id"
                value={formData.id}
                className="form-control"
                placeholder="ID"
                readOnly
              />
            </div>

            <div className="mb-3">
              <label htmlFor="company_name-field" className="form-label">
                Company Name
              </label>
              <select
                id="company"
                className="form-control"
                placeholder="Company Name"
                value={formData.company}
                onChange={handleInputChange}
                required
              >
                <option key="default">Select Company</option>
                {companyData.map((company, index) => (
                  <>
                    <option key={index} value={company.id}>
                      {company.name}
                    </option>
                  </>
                ))}
              </select>
            </div>

            {/* <div className="mb-3">
              <label htmlFor="logo-field" className="form-label">
                Machine Image
              </label>

              <input
                type="file"
                // accept="images/*"
                id="image"
                className="form-control"
                placeholder="Machine Image"
                // value={formData.image}
                onChange={handleInputChange}
                required
              />
              { {editedMachine && editedMachine.image && (
  <div className="mt-2">
    <img src={editedMachine.image} height="50" alt="Existing Machine" />
  </div>
)} }
            </div> */}

            <div className="mb-3">
              <label htmlFor="machine_name-field" className="form-label">
                Machine Name
              </label>

              <input
                type="text"
                id="name"
                className="form-control"
                placeholder="Machine Name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>
<div className="mb-3">
  <label htmlFor="machine_type" className="form-label">
    Machine Type
  </label>
  <select
    id="machine_type"
    className="form-control"
    value={formData.manual === true ? "manual" : formData.manual === false ? "automatic" : ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        manual: e.target.value === "manual",
        machine_type: e.target.value,
      })
    }
    required
  >
    <option value="">Select Type</option>
    <option value="automatic">Automatic</option>
    <option value="manual">Manual</option>
  </select>
</div>

            <div className="mb-3">
              <label htmlFor="topic-field" className="form-label">
                Topic
              </label>

              <input
                type="text"
                id="topic"
                className="form-control"
                placeholder="Topic"
                value={formData.topic}
                onChange={handleInputChange}
                required
              />
            </div>

          

            <div className="mb-3">
              <label htmlFor="ideal_cycle_time-field" className="form-label">
                Ideal cycle TIme
              </label>
              <input
                type="number"
                id="ideal_cycle_time"
                className="form-control"
                placeholder="Enter Ideal Cycle Time"
                value={formData.ideal_cycle_time}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="description" className="form-label">
                Description
              </label>
              <input
                type="text"
                id="description"
                className="form-control"
                placeholder="Description"
                value={formData.description}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="design_capacity-field" className="form-label">
                Design Capacity
              </label>
              <input
                type="number"
                id="design_capacity"
                className="form-control"
                placeholder="Design Capacity"
                value={formData.design_capacity}
                onChange={handleInputChange}
                required
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setmodal_list(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success"
                id="add-btn"
                onClick={handleSubmit}
              >
                {" "}
                {editedMachine ? "Edit Machine" : "Add Machine"}
              </button>
              {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </React.Fragment>
  );
};

export default Machine;
